import {userConstants} from '../constants/user.constants'
import {createAPIClient} from '../services/api'

export function logOutAction () {
  return dispatch => {
    dispatch({type: userConstants.LOGOUT})
  }
}

export function getBasicData (callback) {
  return dispatch => {
    getAccountDetails()
      .then(user => {
        getAccountLocations()
          .then(locationsData => {
            user = {...user, locations_data: locationsData}
            dispatch({type: userConstants.GET_USER_DETAILS_SUCCESS, user})
            if (callback) callback(null)
          })
      })
      .catch(error => {
        if (callback) callback(error)
        console.log(error)
      })
  }
}

function getAccountDetails () {
  const API = createAPIClient()
  // view.setAccountLoadedState(false)
  return API.get('/api/me')
    .then(response => {
      const {data} = response
      return Promise.resolve(data.response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

function getAccountLocations () {
  const API = createAPIClient()
  return API.get('/api/locations')
    .then(response => {
      const {data} = response
      return Promise.resolve(data.response.items)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function updateAccountDetails (data, callback, errorhandle) {
  return dispatch => {
    const api = createAPIClient()
    api.put('/api/me', data)
      .then(response => {
        const {data} = response
        let user = data.response
        getAccountLocations()
          .then(locationsData => {
            user = {...user, locations_data: locationsData}
            dispatch({type: userConstants.GET_USER_DETAILS_SUCCESS, user})
            callback()
          })
      })
      .catch(error => {
        errorhandle(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/account.action.js